export default () => ({
  basicInfo: {
    display: 'grid',
    grid: '50px / 200px 200px',
    marginBottom: '30px',
  },
  addAccessForAdmin: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '10px 0',
  },
});
